import React from "react";
import { array, number, string } from "prop-types";

import Headline from "../../atoms/headline";
import CustomStoryCard7 from "../../molecules/custom-story-card7";
import { wruUserEvent } from "../../helper/api";
import { readCookie } from "../../helper/cookies";
import translate from "../../../components/translate";

import "./alsoRead.m.css";

const AlsoRead = ({ list, name, merchantId, publisherName }) => {
  if (!(list && list.length)) {
    return null;
  }

  const items = list.map((ele) => ({
    headline: ele.Description,
    url: `/${ele.Slug}`,
    "hero-image-s3-key": ele.ImageUrl,
    "hero-image-metadata": ele.ImageMetaData,
  }));

  const handleUserClick = (item) => () => {
    const body = {
      uid: readCookie("thinmint"),
      Cid: item.Cid, // article id
      eid: "EVENT1",
      merchantId: `${merchantId}`,
      ip: "",
      timestamp: `${new Date().getTime()}`,
      eventType: "RECOMMENDATION_VIEW_EVENT",
      recommendation: "wru",
      ref: name, // the heading of the recommendation widget
      userAgent:
        "Mozilla/5.0 (iPhone; CPU iPhone OS 11_0 like Mac OS X) AppleWebKit/604.1.38 (KHTML, like Gecko) Version/11.0 Mobile/15A372 Safari/604.1",
    };

    wruUserEvent(merchantId, body).then((i) => console.log("Wru click event", i));
  };

  return (
    <div styleName="wrapper" className="also-read">
      <Headline text={translate(publisherName, "also_read")} headerType={8} useAlternateHeadline />

      <div styleName="stories">
        {items.slice(0, 4).map((item, index) => (
          <div key={index} onClick={handleUserClick(item)}>
            <CustomStoryCard7 story={item} useAlternateHeadline />
          </div>
        ))}
      </div>
    </div>
  );
};

AlsoRead.propTypes = {
  list: array,
  merchantId: number,
  name: string,
  publisherName: string,
};

export default AlsoRead;
